import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EPRMCode } from '../../../services/individualReport';
import PageSection from '../components/PageSection/PageSection';
// import DiscussIcon from './../../../assets/icons/comments-solid.svg';
// import EvaluateIcon from './../../../assets/icons/arrows-rotate-solid.svg';
import SeekIcon from './../../../assets/icons/hand-holding-heart-solid.svg';
import {
  ContentCont,
  Description,
  Icon,
  IconCont,
  InngerCont,
  SuggestionCard,
  Title,
} from './SuggestionsSection.styles';

// const ICONS: Record<number, string> = {
//   1: SeekIcon,
//   2: SeekIcon,
//   3: DiscussIcon,
// };

interface ISuggestionsSection {
  prmCode: EPRMCode;
}

const SuggestionsSection: FC<ISuggestionsSection> = ({ prmCode }) => {
  const { t } = useTranslation();

  const hints = useMemo(
    () => [
      {
        id: 1,
        title: t(`results.report.suggestions.hints.${prmCode}.seek.title`),
        text: t(`results.report.suggestions.hints.${prmCode}.seek.description`),
      },
      {
        id: 2,
        title: t(`results.report.suggestions.hints.${prmCode}.evaluate.title`),
        text: t(`results.report.suggestions.hints.${prmCode}.evaluate.description`),
      },
      {
        id: 3,
        title: t(`results.report.suggestions.hints.${prmCode}.discuss.title`),
        text: t(`results.report.suggestions.hints.${prmCode}.discuss.description`),
      },
    ],
    [prmCode, t]
  );

  return (
    <PageSection ariaLabel="suggestions">
      <PageSection.Header>
        <PageSection.Header.Title tag="h3" title={t('results.report.suggestions.title')} />
      </PageSection.Header>
      <PageSection.Content isUnstyled>
        <Description>{t('results.report.suggestions.description')}</Description>
        <ContentCont>
          {hints.map(({ id, title, text }) => (
            <SuggestionCard id="SuggestionCard" key={id}>
              <InngerCont id="InnerCont">
                <IconCont id="IconCont">
                  <Icon id="Icon" src={SeekIcon} title="icon" />
                </IconCont>
                <Title id="Title" as="h4">
                  {title}
                </Title>
                <Description id="Description" as="p">
                  {text}
                </Description>
              </InngerCont>
            </SuggestionCard>
          ))}
        </ContentCont>
      </PageSection.Content>
    </PageSection>
  );
};

export default SuggestionsSection;
